import React from "react";

const Section8 = () => {
  return (
    <div className="w-full bg-[#DA2128] py-[30px] md:py-[50px]">
      <div className="w-[90%] md:w-[85%] mx-auto text-center">
      <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-white font-bold mb-10">
      Work With a Trusted New York Web Development Agency
        </h2>

        <p className="text-[16px] md:text-[18px] text-white leading-[24px] mb-8 max-w-[700px] mx-auto">
          Let Mean3 turn your idea into a high-converting, beautifully crafted website that drives growth. Benefit from industry-certified experts, innovative technology, and proven client success.
        </p>

        <p className="text-[16px] md:text-[18px] text-white leading-[24px] mb-10 max-w-[700px] mx-auto font-semibold">
          📞 Ready to grow your brand with NYC's top web developers?
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="https://mean3.com/contact-mean3"
            className="bg-white hover:bg-gray-100 text-[#DA2128] hover:text-[#b71c22] text-[14px] md:text-[16px] font-semibold px-6 py-3 rounded-[8px] transition-all duration-300 inline-block text-center"
          >
            Get a Free Consultation Today
          </a>
        </div>
      </div>
    </div>
  );
};

export default Section8;
